module.exports = __webpack_public_path__ + "static/media/home_education_512.c685ba00.png";